<template>
  <div class="box">
    <span class="version">version:{{ network.version }} device:{{ network.deviceId }}</span>
    <div class="hearder">
      <div class="row">
        <div class="name">{{ data.organizationName }}</div>
        <img style="width:33vw;margin:0 0 0 3vw" v-if="data.efficiency > 80 || data.efficiency === 80"
          src="@/assets/visualization/hare.svg" />
        <img style="width:26vw;margin:1vh 0 0 3vw"
          v-if="(data.efficiency > 60 && data.efficiency < 80) || data.efficiency === 60"
          src="@/assets/visualization/rabbit.svg" />
        <img style="width:41vw;margin:3.2vh 0 0 3vw" v-if="data.efficiency > 40 && data.efficiency < 60"
          src="@/assets/visualization/fastTortoise.svg" />
        <img style="width:25.4vw;margin:1.2vh 0 0 4vw" v-if="data.efficiency < 40 || data.efficiency === 40"
          src="@/assets/visualization/slowTortoise.svg" />
        <!-- <div>
          <div>产能效率</div>
          <div class="efficiency">{{ data.efficiency }}%</div>
        </div> -->
        <div class="date">
          <div>
            <span style="font-size: 30px;">{{ dateweek.day }} {{ dateweek.week }}</span>
            <span class="mock-block">
              <img class="icon" src="@/assets/visualization/calendar.svg" />
            </span>
          </div>
          <div>
            <span style="font-size: 30px;">{{ dateweek.time }}</span>
            <span class="mock-block">
              <img class="icon" src="@/assets/visualization/time.svg" />
            </span>
          </div>
          <div>
            <span style="font-size: 30px;color: red;" v-if="network.msg">{{network.msg}}</span>
          </div>
        </div>
      </div>
      <!-- <div class="row">
        产出数量
      </div>
      <div class="row">
        {{ Number(data.reportQuantity).toLocaleString() }}/{{ Number(data.plannedQuantity).toLocaleString() }}
      </div> -->
      <div class="overview">
        <div class="outputs">
          <div class="title">
            生产中数量
          </div>
          <div :class="getFontSize()">
            <div class="number-60">{{ formatNumber(data.reportQuantity) }}/{{ formatNumber(data.plannedQuantity) }}</div>
            <!-- {{ Number(data.reportQuantity).toLocaleString() }}/{{ Number(data.plannedQuantity).toLocaleString() }} -->
          </div>
        </div>
        <div :class="getEfficiency()">
          <div class="title">
            当日生产效率
          </div>
          <div class="number">
            {{ data.efficiency }}%
          </div>
        </div>
      </div>
    </div>
    <div style="overflow:hidden;position: relative;" ref='scrollContainer' :style="{
      '--playstate':data.departmentKanBanDtoListAll&&data.departmentKanBanDtoListAll.length>2?'runing':'paused',
      '--scrollduration':data.departmentKanBanDtoListAll&&data.departmentKanBanDtoListAll.length>2?'60s':'30s'
      }">
      <div class="scroll-box" ref='container'>
        <div class="work-section" :id="`work${index}`" :ref="`work${index}`"
          v-for="(item, index) in data.departmentKanBanDtoListAll" :key="index">
          <div class="work-section-products" ref='scrollSubContainer' :style="{
            '--duration': item.processGroupKanBanDtoList&&item.processGroupKanBanDtoList.length>4?'60s':'30s',
            '--productsplaystate':item.processGroupKanBanDtoList&&item.processGroupKanBanDtoList.length>4?'runing':'paused'
            }">
            <div  class="work-section-products-scroll" ref="subContainer">
              <div class="item" v-for="(items, index) in item.processGroupKanBanDtoList" :key="index">
                <div class="row">
                  <div>
                    <div class="info text-ellipsis">{{ items.productCode }}</div>
                    <img v-if="items.iconUrl != null && items.iconUrl != ''" :src="items.iconUrl.url"
                      style="width:200px;height:156px;margin:10px 18px 0 0" />

                    <div v-else class="imgWrap">
                      <img src="@/assets/visualization/defaultProduct.svg"
                        style="width:123px;height:123px;vertical-align: middle;" />
                    </div>
                  </div>
                  <div style="flex:auto;text-align:left">
                    <div class="info" style="text-align:right;padding:0 0 12px"> {{
          Number(items.reportQuantity).toLocaleString() }}/{{
          Number(items.plannedQuantity).toLocaleString() }}</div>
                    <div class="g-container">
                      <div class="g-progress"
                        :style="{ 'background': '#1890FF', 'width': `${getPercent(Number(items.reportQuantity), Number(items.plannedQuantity))}%` }">
                      </div>
                      <div class="name">{{ items.productName }}</div>
                      <div class="info ellipsis">{{ items.specification }}</div>
                    </div>
                  </div>
                </div>
                <!-- <div class="g-container">
                <div class="g-progress"
                  :style="{ 'background': data.efficiency > 60 ? '#00B578' : '#FA5151', 'width': `${(Number(items.reportQuantity)) / Number(items.plannedQuantity) * 100}%` }">
                </div>
              </div> -->
              </div>
            </div>
            <div class="work-section-products-scroll1" ref="subContainer">
              <div class="item" v-for="(items, index) in item.processGroupKanBanDtoList" :key="index">
                <div class="row">
                  <div>
                    <div class="info text-ellipsis">{{ items.productCode }}</div>
                    <img v-if="items.iconUrl != null && items.iconUrl != ''" :src="items.iconUrl.url"
                      style="width:200px;height:156px;margin:10px 18px 0 0" />

                    <div v-else class="imgWrap">
                      <img src="@/assets/visualization/defaultProduct.svg"
                        style="width:123px;height:123px;vertical-align: middle;" />
                    </div>
                  </div>
                  <div style="flex:auto;text-align:left">
                    <div class="info" style="text-align:right;padding:0 0 12px"> {{
          Number(items.reportQuantity).toLocaleString() }}/{{
          Number(items.plannedQuantity).toLocaleString() }}</div>
                    <div class="g-container">
                      <div class="g-progress"
                        :style="{ 'background': '#1890FF', 'width': `${getPercent(Number(items.reportQuantity), Number(items.plannedQuantity))}%` }">
                      </div>
                      <div class="name">{{ items.productName }}</div>
                      <div class="info ellipsis">{{ items.specification }}</div>
                    </div>
                  </div>
                </div>
                <!-- <div class="g-container">
                <div class="g-progress"
                  :style="{ 'background': data.efficiency > 60 ? '#00B578' : '#FA5151', 'width': `${(Number(items.reportQuantity)) / Number(items.plannedQuantity) * 100}%` }">
                </div>
              </div> -->
              </div>
            </div>
          </div>
          <div class="work-section-tab">
            <div class="name">{{ item.organizationName }}</div>
            <div class="statistics">{{ Number(item.reportQuantity).toLocaleString() }}/{{
          Number(item.plannedQuantity).toLocaleString() }}</div>
          </div>
        </div>
      </div>
      <!-- <div class="scroll-box1" ref='container'>
        <div class="work-section" :id="`work${index}`" :ref="`work${index}`"
          v-for="(item, index) in data.departmentKanBanDtoListAll" :key="index">
          <div class="work-section-products" ref='scrollSubContainer' :style="{
            '--duration': item.processGroupKanBanDtoList&&item.processGroupKanBanDtoList.length>4?'60s':'30s',
            '--productsplaystate':item.processGroupKanBanDtoList&&item.processGroupKanBanDtoList.length>4?'runing':'paused'
            }">
            <div  class="work-section-products-scroll" ref="subContainer">
              <div class="item" v-for="(items, index) in item.processGroupKanBanDtoList" :key="index">
                <div class="row">
                  <div>
                    <div class="info">{{ items.productCode }}</div>
                    <img v-if="items.iconUrl != null && items.iconUrl != ''" :src="items.iconUrl.url"
                      style="width:200px;height:156px;margin:10px 18px 0 0" />

                    <div v-else class="imgWrap">
                      <img src="@/assets/visualization/defaultProduct.svg"
                        style="width:123px;height:123px;vertical-align: middle;" />
                    </div>
                  </div>
                  <div style="flex:auto;text-align:left">
                    <div class="info" style="text-align:right;padding:0 0 12px"> {{
          Number(items.reportQuantity).toLocaleString() }}/{{
          Number(items.plannedQuantity).toLocaleString() }}</div>
                    <div class="g-container">
                      <div class="g-progress"
                        :style="{ 'background': '#1890FF', 'width': `${getPercent(Number(items.reportQuantity), Number(items.plannedQuantity))}%` }">
                      </div>
                      <div class="name">{{ items.productName }}</div>
                      <div class="info ellipsis">{{ items.specification }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="work-section-products-scroll1" ref="subContainer">
              <div class="item" v-for="(items, index) in item.processGroupKanBanDtoList" :key="index">
                <div class="row">
                  <div>
                    <div class="info">{{ items.productCode }}</div>
                    <img v-if="items.iconUrl != null && items.iconUrl != ''" :src="items.iconUrl.url"
                      style="width:200px;height:156px;margin:10px 18px 0 0" />

                    <div v-else class="imgWrap">
                      <img src="@/assets/visualization/defaultProduct.svg"
                        style="width:123px;height:123px;vertical-align: middle;" />
                    </div>
                  </div>
                  <div style="flex:auto;text-align:left">
                    <div class="info" style="text-align:right;padding:0 0 12px"> {{
          Number(items.reportQuantity).toLocaleString() }}/{{
          Number(items.plannedQuantity).toLocaleString() }}</div>
                    <div class="g-container">
                      <div class="g-progress"
                        :style="{ 'background': '#1890FF', 'width': `${getPercent(Number(items.reportQuantity), Number(items.plannedQuantity))}%` }">
                      </div>
                      <div class="name">{{ items.productName }}</div>
                      <div class="info ellipsis">{{ items.specification }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="work-section-tab">
            <div class="name">{{ item.organizationName }}</div>
            <div class="statistics">{{ Number(item.reportQuantity).toLocaleString() }}/{{
          Number(item.plannedQuantity).toLocaleString() }}</div>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    dateweek: {
      type: Object
    },
    network: {
            type: Object
        },
    payload: {
      type: Array,
      default: () => [],
    },
    organizationName: String
  },
  data() {
    return {
      data: {
        organizationName: '',
        plannedQuantity: '',
        reportQuantity: '',
        efficiency: '',
        departmentKanBanDtoList: [],
        departmentKanBanDtoListAll: [],
      },
      scrollTimer: null,
      scrollSubTimer: null,
      subIndex: 0,
      subMaxLength: 0,
    }
  },
  watch: {
    payload() {
      this.setpayload()
    }
  },
  created() {
    this.subIndex=0
    this.setpayload()
  },
  // 挂载时间
  methods: {
    setpayload() {
      this.subMaxLength=this.payload[0].departmentKanBanDtoList&&this.payload[0].departmentKanBanDtoList.length
      this.subIndex++
      if(this.subIndex>=this.subMaxLength){
        this.subIndex=0
      }
      this.data = {
        organizationName: this.organizationName,
        plannedQuantity: this.payload[0].plannedQuantity,
        reportQuantity: this.payload[0].reportQuantity,
        efficiency: this.payload[0].efficiency,
        departmentKanBanDtoListAll: this.payload[0].departmentKanBanDtoList.slice(this.subIndex,this.subIndex+1),
        departmentKanBanDtoList: [],
      }
      let len = this.data.departmentKanBanDtoListAll.length
      for (let i = 0; i < len; i++) {
        let item = this.data.departmentKanBanDtoListAll[i]
        // if (item.processGroupKanBanDtoList != null && item.processGroupKanBanDtoList.length > 0) {
        //   // 只能支持一条产品线产品最多为4个
        //   this.$set(item, 'processGroupKanBanDtoList', item.processGroupKanBanDtoList.slice(0, 8))
        // }
        // console.log(this.$refs.scrollSubContainer)
        // this.$refs.scrollSubContainer.style.setProperty('--duration', '10s')
        
      }
      // if (this.data.departmentKanBanDtoListAll && this.data.departmentKanBanDtoListAll.length > 0) {
      //   //一屏最多只能支持两条产品线
      //   this.data.departmentKanBanDtoList = this.data.departmentKanBanDtoListAll.slice(0, 2)

      //   this.data.departmentKanBanDtoList.forEach((item) => {
      //     if (item.processGroupKanBanDtoList != null && item.processGroupKanBanDtoList.length > 0) {
      //       // 只能支持一条产品线产品最多为4个
      //       this.$set(item, 'processGroupKanBanDtoListShow', item.processGroupKanBanDtoList.slice(0, 4))
      //     }
      //   })
      //   // this.productionCarousel()
      // }
    },
    // 将数字转换w,kw单位
    formatNumber(number) {
      let num = number ? Math.round(number) : 0
      let result = ''
      if (num.toString().length > 5 && num.toString().length < 7) {
        result = (num / 1e4).toFixed(1) + 'w';
      } else if (num.toString().length >= 7) {
        result = (num / 1e7).toFixed(1) + 'kw';
      } else {
        result = num
      }
      return result
    },
    getPercent(reportQuantity,plannedQuantity){
      return  (reportQuantity/plannedQuantity)>1?100:(reportQuantity/plannedQuantity)*100
    },
    getFontSize(){
      let len = this.data.reportQuantity.toString().length + this.data.plannedQuantity.toString().length
      if(len <=8){
        return 'number'
      }else if(len>8&&len<=12){
        return 'number-60'
      }else{
        return 'number-40'
      }
    },
    getEfficiency(){
      if(this.data.efficiency>=60){
        return 'high-rate'
      }else if(this.data.efficiency>=40&&this.data.efficiency<60){
        return 'middle-rate'
      }else {
        return 'low-rate'
      }
    },
    getBgColor(val) {
      if (val <= 40) {
        return '#FA5151'
      } else if (val > 40 && val < 60) {
        return '#F5B130'
      } else {
        return '#00B578'
      }
    },

  },
  beforeCreate() {
    document.getElementsByTagName('body')[0].style.margin = '0'
  },
}
</script>

<style scoped lang="less">
* {
  margin: 0;
  padding: 0;
}

.box {
  height: 100%;
  width: 100%;

  .hearder {
    height: 640px;
    width: 100vw;
    background: #D0E9FF;
    font-size: 54px;
    color: #333;
    padding: 40px 50px 20px;
    box-sizing: border-box;

    .row:first-child {
      margin-bottom: 46px;
      display: flex;
      justify-content: space-between;

      .name {
        text-align: left;
        width: 220px;
        word-wrap: break-word;
      }

      img {
        // width: 344px;
        // height: 320px;
      }

      div {
        .efficiency {
          font-size: 64px;
        }
      }

      .date {
        text-align: right;

        .icon {
          width: 30px;
          height: auto;
          vertical-align: middle;
        }
      }
    }

    .row:last-child {
      font-size: 110px;
    }

    .overview {
      color: #fff;
      height: 250px;
      display: flex;
      justify-content: space-between;

      &>div {
        display: inline-block;
        text-align: center;
        border-radius: 10px 10px 10px 10px;
        padding: 40px 0;
        width: calc(50% - 10px);
        height: 250px;
        box-sizing: border-box;

        .title {
          font-size: 50px;
          margin-bottom: 24px;
        }

        .number {
          font-size: 80px;
        }

        .number-60 {
          font-size: 60px;
        }

        .number-40 {
          font-size: 40px;
        }
      }

      .outputs {
        background-color: #333;
      }

      .high-rate {
        background-color: #00B578;
      }

      .middle-rate {
        background-color: #F5B130;
      }

      .low-rate {
        background-color: #FA5151;
      }
    }
  }
  --scrollduration:30s;
  --playstate:paused;
  .scroll-box {
    height: auto;
    padding: 0 50px;
    margin: 20px 0 40px;
    animation: scroll var(--scrollduration) linear 2s infinite;
    animation-play-state: var(--playstate);
  }
  .scroll-box1 {
    height: auto;
    position: absolute;
    padding: 0 50px;
    margin: 20px 0 40px;
    width: 100%;
    top:0;
    left: 0;
    animation: scroll1 var(--scrollduration) linear 2s infinite;
    animation-play-state: var(--playstate);
  }

  .work-section {
    // height: 600px;
    height: auto;
    width: calc(100vw - 100px);
    padding: 0 0 40px;

    .work-section-products{
      overflow:hidden;
      position: relative;
      --duration:30s;
      --productsplaystate:paused;
      .work-section-products-scroll{
        animation: scroll var(--duration) linear 2s infinite;
        animation-play-state: var(--productsplaystate);
      }
      .work-section-products-scroll1{
        position: absolute;
        width: 100%;
        top:0;
        left: 0;
        animation: scroll1 var(--duration) linear 2s infinite;
        animation-play-state: var(--productsplaystate);
      }
    }

    &-products {
      // height: 480px;
      height: calc(100vw - 50px);
      overflow: hidden;
      // display: grid;
      // grid-template-columns: 1fr 1fr;
      border: solid 5px #333;
      border-radius: 10px 10px 0 0;
      color: #000;

      .item {
        background: #FFF;
        border-bottom: solid 2px #333;
        padding: 18px 24px;
        height: 240px;
        box-sizing: border-box;

        .row {
          display: flex;

          .imgWrap {
            width: 200px;
            height: 156px;
            line-height: 156px;
            border-radius: 5px 5px 5px 5px;
            border: 2px solid #DDDDDD;
            box-sizing: border-box;
            margin: 12px 18px 0 0;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .name {
            // width: 64.8vw;
            font-size: 48px;
            margin: 30px 0 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: left;
            line-height: 48px;
          }

          .info {
            font-size: 30px;
            line-height: 30px;
          }
          .text-ellipsis{
            width: 220px;
            white-space: nowrap; 
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .ellipsis{
            word-break: break-all;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            lines: 2;
            text-overflow:ellipsis;
          }
        }

        .g-container {
          width: 100%;
          height: 20px;
          // border-radius: 25px;
          background: #DDDDDD;
          border-radius: 10px;
        }

        .g-progress {
          // width: 70%;
          height: inherit;
          // border-radius: 25px 0 0 25px;
          background: #00B578;
          border-radius: 10px;
        }

        // meter {
        //   width: 100%;
        //   height: 40px;
        // }
      }
    }

    &-tab {
      height: 76px;
      background: #333;
      color: #fff;
      display: flex;
      justify-content: space-between;
      font-size: 54px;
      padding: 16px 40px;
      border-radius: 0 0 10px 10px;

      .name,
      .statistics {
        font-family: "Alibaba PuHuiTi 2.0 105 Heavy", 'Avenir', Helvetica, Arial, sans-serif;
        text-align: left;
        height: 76px;
        line-height: 76px;
      }

      .statistics {
        text-align: right;
      }
    }
  }
}
.version{
    font-size:20px;
    position: absolute;
    left: 0px;
    top: 10px;
    color:rgba(0, 0, 0, 0.3)
}

@keyframes scroll {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(-100%);
  }
}

@keyframes scroll1 {
  0% {
    transform: translateY(100%);
  }
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/production/Progress.vue